import React from 'react';
import PropTypes from 'prop-types';

import Button, { BUTTON_TYPES } from 'shared-components/Button/Button';
import styles from './CSVModal.module.css';

const SelectedFileScreen = ({
  title,
  selectedFile,
  onClearState,
  onClose,
  onSubmit,
}) => (
  <div className={styles.content}>
    <h1>{title}</h1>
    <div className={styles.selectedFile}>
      <div>{selectedFile.name}</div>
      <button type="button" className={styles.closeFile} onClick={onClearState}>
        <i className="fal fa-times" />
      </button>
    </div>
    <div className={styles.buttons}>
      <Button
        onClick={onClose}
        buttonType={BUTTON_TYPES.TERTIARY_INVERSE}
        style={{ width: 120 }}
      >
        Cancel
      </Button>
      <Button onClick={onSubmit} style={{ width: 120 }}>
        Next
      </Button>
    </div>
  </div>
);

SelectedFileScreen.propTypes = {
  title: PropTypes.string.isRequired,
  selectedFile: PropTypes.shape().isRequired,
  onClearState: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default SelectedFileScreen;
